import React from 'react';
import styled from 'styled-components';

//const DEFAULT_PROFILE_PICTURE_URL = '/img/avatar-default.png';

type ProfileProps = {
    profileUrl: string;
    width?: string;
}
const ProfileIcon = ({profileUrl, width}: ProfileProps) => {
    /*const [userPictureUrl, setUserPictureUrl] = useState<null | string>(null);
    useEffect(() => {
        const fetchCurrentUserForProfilePicture = async () => {
            const {avatar} = await getCurrentUser();
            if (!!avatar && avatar !== DEFAULT_PROFILE_PICTURE_URL) setUserPictureUrl(avatar);
        };
        fetchCurrentUserForProfilePicture();
    });*/

    return (
        <a href={profileUrl} target="_blank" rel="noopener noreferrer">
            <IconContainer width={width}>
                {/*USE WHEN NEEDED TO SHOW PROFILE PICTURE{
                    !!userPictureUrl ? (
                        <ProfilePicture src={userPictureUrl} />
                    ): (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
                    )
                }*/}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
            </IconContainer>
        </a>
    )
};

type IconContainerProps = { width?: string }
const IconContainer = styled.div<IconContainerProps>`
  position: relative;
  overflow: hidden;
  width: ${({ width }) => width ? width : '24px'};
  height: ${({ width }) => width ? width : '24px'};
  svg {
    width: ${({ width }) => width ? width : '24px'};
    height: ${({ width }) => width ? width : '24px'};
  }
`;

/*const ProfilePicture = styled.img`
  width: 100%;
  border-radius: 3px;
`;*/

export default ProfileIcon;
